import { render, staticRenderFns } from "./VacancyWizardSubCategories.vue?vue&type=template&id=5b6aaa8e&scoped=true&"
import script from "./VacancyWizardSubCategories.vue?vue&type=script&lang=js&"
export * from "./VacancyWizardSubCategories.vue?vue&type=script&lang=js&"
import style0 from "./VacancyWizardSubCategories.vue?vue&type=style&index=0&id=5b6aaa8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6aaa8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol})
